export default __webpack_public_path__ + "static/media/cover1.07659e4b.jpg";